import { watchEffect } from "@vue/composition-api";
import config, { status } from "@/config";
import * as amplitude from "@amplitude/unified";
import { isLoggedIn } from "@micad/vue-components";
import { userInfo } from "@/modules/auth";
import { getKV } from "@/modules/browserLocalStorage";
import { CLIENT_COOKIE_NAME } from "@/interfaces/common.interfaces";

export const { reset } = amplitude;

export const init = (app: string) => {
  watchEffect(() => {
    if (status.loaded) {
      const { AMPLITUDE_API_KEY } = config;

      if (AMPLITUDE_API_KEY) {
        amplitude.initAll(AMPLITUDE_API_KEY, { analytics: { autocapture: true } });
      }
    }
  });

  watchEffect(() => {
    if (isLoggedIn.value && userInfo.userId) {
      const clientKey = getKV(CLIENT_COOKIE_NAME) || "";
      const userRole = userInfo.micadUser
        ? "MicadAdmin"
        : userInfo.appRoles
        ? userInfo.appRoles["Accounts"]
        : "None";

      amplitude.setIdentity({
        userId: `${clientKey}:${userInfo.userId}`,
        userProperties: {
          app,
          clientKey,
          userId: userInfo.userId,
          userRole,
          micadUser: userInfo.micadUser,
        },
      });
    } else {
      amplitude.reset();
    }
  });
};
